import React from 'react';
import ShieldIcon from '@mui/icons-material/Shield';
export function Guarantee() {
  return <section className="py-12 bg-brand-dark text-white" data-id="element-175">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center" data-id="element-176">
        <ShieldIcon sx={{
        fontSize: 56
      }} className="text-brand-gold mb-4" data-id="element-177" />
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-178">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <div className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-179">
          <p className="mb-3" data-id="element-180">Abrís los tomos. Los usás en tu cocina.</p>
          <p className="mb-3" data-id="element-181">
            Si en 7 días no es lo que esperabas:
            <br data-id="element-182" />
            <span className="text-brand-gold font-bold text-2xl" data-id="element-183">
              devolución del 100%
            </span>
            <br data-id="element-184" />
            sin formularios, sin drama.
          </p>
          <p className="text-sm text-gray-400 mt-5 uppercase tracking-widest" data-id="element-185">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}